// get_walkthrough_categorys
export const GET_WALKTHROUGH_CATEGORY = 'get_walkthrough_categorys';
export const GET_WALKTHROUGH_CATEGORY_SUCCESSFUL =
  'get_walkthrough_categorys_successfull';
export const GET_WALKTHROUGH_CATEGORY_FAILED =
  'get_walkthrough_categorys_failed';

// submit_walkthrough_category
export const SUBMIT_WALKTHROUGH_CATEGORY = 'submit_walkthrough_category';
export const SUBMIT_WALKTHROUGH_CATEGORY_SUCCESSFUL =
  'submit_walkthrough_category_successfull';
export const SUBMIT_WALKTHROUGH_CATEGORY_FAILED =
  'submit_walkthrough_category_failed';

// delete_walkthrough_category
export const DELETE_WALKTHROUGH_CATEGORY = 'delete_walkthrough_category';
export const DELETE_WALKTHROUGH_CATEGORY_SUCCESSFUL =
  'delete_walkthrough_category_successfull';
export const DELETE_WALKTHROUGH_CATEGORY_FAILED =
  'delete_walkthrough_category_failed';
